import React from 'react';
import Text from 'components/react-styled-core/Text';
import Box from 'components/react-styled-core/Box';
import i18n from 'lib/i18n';

const Note = ({ note, children, ...props }) => (
    <Box
        {...props}
    >
        <Text
            color="red:80"
            fontWeight="bold"
            mr="1x" // 4px
        >
            {note || i18n._('Note')}:
        </Text>
        <Text color="red:80">
            {children}
        </Text>
    </Box>
);

export default Note;
